/* ─────────────────────────────────────────────
   BuzzPatch AOA – Vanilla JS
   • FAQ accordion
   • Smooth scrolling
   • Sticky bar scroll hide/show
───────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', function () {

  /* ── FAQ Accordion ───────────────────────────── */
  document.querySelectorAll('.adv-faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.adv-faq-item');
      var answer = item.querySelector('.adv-faq-a');
      var arrow  = btn.querySelector('.adv-faq-arrow');

      var isOpen = item.classList.contains('is-open');

      // Close any other open item
      document.querySelectorAll('.adv-faq-item.is-open').forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
          other.querySelector('.adv-faq-a').style.maxHeight = null;
          other.querySelector('.adv-faq-arrow').style.transform = '';
        }
      });

      if (isOpen) {
        item.classList.remove('is-open');
        answer.style.maxHeight = null;
        arrow.style.transform  = '';
      } else {
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        arrow.style.transform  = 'rotate(180deg)';
      }
    });
  });

  /* ── Smooth Scrolling for anchor links ──────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── Sticky bar: hide until scrolled past hero ─ */
  var stickyBar = document.querySelector('.adv-sticky-bar');
  if (stickyBar) {
    var hero = document.querySelector('.adv-hero-img-wrap');

    function onScroll() {
      if (!hero) {
        stickyBar.classList.add('is-visible');
        return;
      }
      var heroBottom = hero.getBoundingClientRect().bottom;
      if (heroBottom < 0) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

});
